import Employee from './employee'
export enum EmployeeClasses { SALARY = 'SALARY' }

export default interface EmployeeClass {
  id: string;
  description: string;

  // Navigation
  employees?: Employee[];
}
